export enum FeaturedTypes {
  songs = 'songs',
  playlists = 'playlists',
  albums = 'albums'
}
